import { $qs, $qsa } from 'fxdom/es';
import { NessLabsConstantS } from '../../S/Constant/module/NessLabsConstantS.js';
import { NessUtilF } from '../../../Ness/Util/F/Function/module/NessUtilF.js';
import { NessLabsS } from '../../S/Function/module/NessLabsS.js';
import { each, go } from 'fxjs/es';
import { UtilS } from '../../../Util/S/Function/module/UtilS.js';

export const initializeCanvases = async () => {
  const canvas = $qs('.my-character');

  const { MAIN, THUMBNAIL } = NessLabsConstantS.CHARACTER_CANVAS_SIZE[NessUtilF.isMobile() ? 'MOBILE' : 'PC'];
  const is_login = !UtilS.is_empty_object(box().is_user) && box().is_user.type !== 'TEMP';
  const has_character = !!box().characters.length;

  const data = is_login
    ? has_character
      ? { canvas, size: MAIN }
      : { canvas, image_url: NessLabsConstantS.NO_CHARACTER, size: MAIN }
    : { canvas, image_url: NessLabsConstantS.DEFAULT_CHARACTER, size: MAIN };

  await NessLabsS.initializeCanvases(data);

  const thumbnails = $qsa('.character-thumbnail');
  go(
    thumbnails,
    each(async (thumbnail) => {
      const image_url = thumbnail.dataset.src || NessLabsConstantS.DEFAULT_CHARACTER;
      const scaled = await NessLabsS.getScaleUpAndCenterCropCanvas(
        image_url,
        THUMBNAIL.SIZE,
        THUMBNAIL.CROP_WIDTH,
        THUMBNAIL.CROP_HEIGHT,
      );
      thumbnail.width = scaled.width;
      thumbnail.height = scaled.height;
      thumbnail.getContext('2d').drawImage(scaled, 0, 0);
    }),
  );
};
